<template>
  <div class="kalem">
       <resultDialog ref="showMessage"></resultDialog>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
     <v-dialog v-model="acentedepartmandialog" max-width="400px">
      <v-toolbar color="info">
        <v-toolbar-title class="white-text">
          <span class="white--text"> {{ $t('Agency-Department') }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text>
          <v-text-field v-model="loadData.Ad" :label="$t('Name_label')"></v-text-field>
          <v-textarea v-model="loadData.Aciklama" :label="$t('Description')"></v-textarea>
        
          <v-text-field
           
            v-model="loadData.AcenteDepartman.EFaturaSeri"
            :label="$t('E-Invoice-Serial')"
          ></v-text-field>
          <v-text-field
           
            v-model="loadData.AcenteDepartman.MasrafMerkezi"
            :label="$t('Expense-Center-v2')"
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="acentedepartmandialog = false" outline color="warning">
            {{$t('Cancel')}}
          </v-btn>
          <v-btn outline color="info" @click="KaydetAcenteDepartman()">
            Kaydet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  <v-dialog v-model="dialogMasrafMerkezi" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{$t('Cost-Center')}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout wrap>
                      <div class="flex md12">

                        <div>
                          <v-text-field :color="color" :label="$t('Cost-Center-Code')" v-model="Masrafmerkezi.Code"
                            :error-messages="errors.collect('Masrafmerkezi.Code')" v-validate="'required|max:50'"
                            data-vv-name="Masrafmerkezi.Code" required></v-text-field>
                        </div>

                        <v-text-field :color="color" :label="$t('Cost-Center-Name')" v-model="Masrafmerkezi.CodeName"
                          :error-messages="errors.collect('Masrafmerkezi.CodeName')" v-validate="'required|max:250'"
                          data-vv-name="Masrafmerkezi.CodeName" required></v-text-field>
                      </div>
                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>


          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          
            <div>
               <v-tooltip bottom>
                <v-btn  color="info" slot="activator" @click="KaydetMasrafMerkezi()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>
                </v-btn>
               
              </v-tooltip>

            </div>
            <v-btn color="blue darken-1" flat @click.native="dialogMasrafMerkezi = false">{{$t('Cancel')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <v-card flat>
      <v-layout row wrap>
        <v-flex xs12 pr-2 md9 sm9>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-tabs
                slot="extension"
                color="grey lighten-4"
                v-model="tabmodel"
              >
                <v-menu bottom right offset-y>
                  <v-btn slot="activator" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile
                      v-for="(item, i) in menuItems"
                      :key="i"
                      @click="menuClick(i)"
                    >
                      <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
                <v-tab :href="`#tab-genel`">{{$t('tab_general')}}</v-tab>
                <v-tab :href="`#tab-ozel`">{{ $t('Private-Information') }}</v-tab>
                <v-tab :href="`#tab-maliyet`">{{$t('Cost')}}</v-tab>
                <v-tab :href="`#tab-komisyon`">{{$t('Commission')}}</v-tab>
                <v-tab :href="`#tab-aciklama`">{{ $t('Description') }}</v-tab>
                <v-tab :href="`#tab-diger`">{{ $t('Other') }}</v-tab>
              </v-tabs>
            </v-flex>

            <v-flex xs12 sm12>
              <v-tabs-items v-model="tabmodel">
                <v-tab-item :id="`tab-genel`">
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-card flat color="grey lighten-5">
                        <v-layout row wrap>
                          <v-flex xs12 sm4 md4>
                            <v-layout row wrap>
                              <v-flex pl-1 xs11 sm11 md11>
                                <genelarama
                                  :autofocuss="true"
                                  apiname="SaticiAra"
                                  :tip="val.kalem.saticiTip"
                                  :label="$t('Seller-Code')"
                                  v-model="val.kalem.satici"
                                ></genelarama>
                              </v-flex>

                              <v-flex xs1 sm1 md1>
                                <v-layout
                                  row
                                  wrap
                                  fill-height
                                  align-end
                                  justify-center
                                >
                                  <minisaticieklecomp
                                    v-model="val.kalem.satici"
                                    :label="'Günlük Tur Satıcı Ekle'"
                                    :saticiKod="val.kalem.saticiTip"
                                  >
                                  </minisaticieklecomp>
                                </v-layout>
                              </v-flex>

                              <v-flex pl-1 xs12 sm12 md12>
                                <genelarama
                                  apiname="SaticiAra"
                                  :tip="12"
                                  label="Tur Operatörü"
                                  v-model="val.kalem.turOperatoru"
                                ></genelarama>
                              </v-flex>

                              <v-flex pl-1 xs12 sm12 md12>
                                <v-combobox
                                  hide-details
                                  :items="turkoduitems"
                                  :label="$t('Tour-Code')"
                                  item-text="Aciklama"
                                  item-value="Kod"
                                  v-model="val.kalem.kalemAcente.TurKodu"
                                >
                                </v-combobox>
                              </v-flex>

                              <v-flex pl-1 xs12 sm12 md12> </v-flex>
                              <v-flex pl-1 xs12 sm12 md12>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <tarihcomp
                                        :etiket="'Tur Baş.'"
                                        v-bind:detaygizle="true"
                                        v-bind:defaultvalue="'ok'"
                                        v-bind:value="val.kalem.donem1"
                                        v-model="val.kalem.donem1"
                                      ></tarihcomp>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <tarihcomp
                                        :etiket="'Tur Bit.'"
                                        v-bind:detaygizle="true"
                                        v-bind:defaultvalue="'ok'"
                                        v-bind:value="val.kalem.donem2"
                                        v-model="val.kalem.donem2"
                                      ></tarihcomp>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>

                              <v-flex pl-1 xs12 sm12 md12>
                                <v-select
                                  hide-details
                                  :items="odemeTipi"
                                  :label="$t('Payment-Type')"
                                  item-text="aciklama"
                                  item-value="kod"
                                  v-model="val.kalem.odeyenTaraf"
                                >
                                </v-select>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex pl-1 xs4 sm4 md4>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-text-field
                                  hide-details
                                  :label="$t('Meeting-Place')"
                                  v-model="val.kalem.kalemAcente.BulusmaYeri"
                                >
                                </v-text-field>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                  <v-flex xs6 sm6 md6>
                                    <tarihcomp
                                      :etiket="$t('Date-of-Meeting')"
                                      v-bind:detaygizle="true"
                                      v-bind:defaultvalue="'ok'"
                                      v-bind:value="
                                        val.kalem.kalemAcente.BulusmaTarihi
                                      "
                                      v-model="
                                        val.kalem.kalemAcente.BulusmaTarihi
                                      "
                                    >
                                    </tarihcomp>
                                  </v-flex>
                                  <v-flex xs6 sm6 md6>
                                    <v-menu
                                      ref="menuacilis"
                                      v-model="menu1"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      :return-value.sync="
                                        val.kalem.kalemAcente.Saat
                                      "
                                      transition="scale-transition"
                                      offset-y
                                      full-width
                                      max-width="290px"
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          hide-details
                                          v-model="val.kalem.kalemAcente.Saat"
                                          label="Saati"
                                          append-icon="access_time"
                                          v-on="on"
                                        >
                                        </v-text-field>
                                      </template>
                                      <v-time-picker
                                        v-if="menu1"
                                        format="24hr"
                                        v-model="val.kalem.kalemAcente.Saat"
                                        full-width
                                        @click:minute="
                                          $refs.menuacilis.save(
                                            val.kalem.kalemAcente.Saat
                                          )
                                        "
                                      >
                                      </v-time-picker>
                                    </v-menu>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex pl-1 xs12 sm12 md12>
                                <v-layout row wrap>
                                  <v-flex xs12 sm12 md12>
                                    <v-textarea
                                      :label="$t('Program')"
                                      v-model="val.kalem.kalemAcente.Program"
                                    >
                                    </v-textarea>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex pl-1 xs4 sm4 md4>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <kur
                                  v-model="val.kalem.satisPara"
                                  :kurtarihi="val.Rez.kayitTarihi"
                                ></kur>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <yuzdeinput
                                :isPositive="true"
                                  :etiket="$t('VAT-Ratio')"
                                  v-model="val.kalem.satis.KDVOran"
                                  :autocomplete="'autocomplete'"
                                  :maxValue="30"
                                ></yuzdeinput>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <v-radio-group
                                  row
                                  hide-details
                                  v-model="val.kalem.P_RP"
                                  column
                                >
                                  <v-radio label="Pax" :value="'P'"></v-radio>
                                  <v-radio :label="$t('Fix')" :value="'R'"></v-radio>
                                </v-radio-group>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                  <v-flex xs8 sm8 md8>
                                    <parainput
                                    :isPositive="true"
                                     simge=""
                                      :etiket="$t('Adult-Sales')"
                                      v-model="val.kalem.yet_Satis"
                                      :autocomplete="'autocomplete'"
                                    ></parainput>
                                  </v-flex>
                                  <v-flex xs4 sm4 md4>
                                    <v-text-field
                                      hide-details
                                      mask="#####"
                                      v-model="val.kalem.yet_KisiSayisi"
                                      :label="$t('Number')"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex
                                xs12
                                v-if="val.kalem.P_RP == 'P'"
                                sm12
                                md12
                              >
                                <v-layout row wrap>
                                  <v-flex xs8 sm8 md8>
                                    <parainput
                                    :isPositive="true"
                                     simge=""
                                      :etiket="$t('Co1Sell')"
                                      v-model="val.kalem.co1_Satis"
                                      :autocomplete="'autocomplete'"
                                    ></parainput>
                                  </v-flex>
                                  <v-flex xs4 sm4 md4>
                                    <v-text-field
                                      hide-details
                                      mask="#####"
                                      v-model="val.kalem.co1_KisiSayisi"
                                      :label="$t('Number')"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                  <v-flex xs6 sm6 md6>
                                    <yuzdeinput
                                    :isPositive="true"
                                      :etiket="$t('Discount-rate')"
                                      v-model="val.kalem.iskonto.oran"
                                      :autocomplete="'autocomplete'"
                                    ></yuzdeinput>
                                  </v-flex>
                                  <v-flex xs6 sm6 md6>
                                    <parainput
                                    :isPositive="true"
                                     simge=""
                                      :etiket="$t('Discount-Amount')"
                                      v-model="val.kalem.iskonto.tutar"
                                      :autocomplete="'autocomplete'"
                                    ></parainput>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex pb-2 xs12 sm12 md12>
                                <v-text-field
                                  hide-details
                                  :label="$t('Discount-Reason')"
                                  v-model="val.kalem.iskonto.iskontoSebebi"
                                >
                                </v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-tab-item>

                <v-tab-item :id="`tab-ozel`">
  <v-layout row wrap>
    <v-flex xs12 sm12 md12>
      <v-card flat color="grey lighten-5">
        <v-layout row wrap>
          <v-flex xs12 sm4 md4>
            <v-layout row wrap>
              <!-- Masraf Merkezi -->
              <v-flex pl-1 xs11 sm11 md11>
                <genelarama
                  apiname="MasrafMerkeziAra"
                  :label="$t('Expense-Center-v2')"
                  v-model="val.kalem.masrafMerkezi"
                ></genelarama>
              </v-flex>
              <v-flex xs1 sm1 md1>
                <v-layout row wrap fill-height align-end justify-center>
                  <v-btn icon small @click="miniEkle('masrafMerkezi')">
                    <v-icon small>add</v-icon>
                  </v-btn>
                </v-layout>
              </v-flex>

              <!-- Acenta Departman -->
              <v-flex pl-1 xs11 sm11 md11>
                <geneltipara
                  tip="AcenteDepartman"
                  v-model="val.kalem.departman"
                >
                </geneltipara>
              </v-flex>
              <v-flex xs1 sm1 md1>
                <v-layout row wrap fill-height align-end justify-center>
                  <v-btn icon small @click="miniEkle('departman')">
                    <v-icon small>add</v-icon>
                  </v-btn>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-select
                  hide-details
                  :items="turturuitems"
                  item-text="text"
                  item-value="value"
                  :label="$t('Tour-type')"
                  v-model="val.kalem.kalemAcente.TurTuru"
                >
                </v-select>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-select
                  hide-details
                  :items="pantipitems"
                  item-text="text"
                  item-value="value"
                  :label="$t('Tour-type-v2')"
                  v-model="val.kalem.kalemAcente.TurTipi"
                >
                </v-select>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex pl-1 xs4 sm4 md4>
            <v-layout row wrap>
              <!-- Gemi -->
              <v-flex pl-1 xs11 sm11 md11>
                <genelarama
                  apiname="SaticiAra"
                  :tip="9"
                  :label="$t('Cruise')"
                  v-model="val.kalem.kalemAcente.Gemi"
                ></genelarama>
              </v-flex>
              <v-flex xs1 sm1 md1>
                <v-layout row wrap fill-height align-end justify-center>
                  <v-btn icon small @click="miniEkle('gemi')">
                    <v-icon small>add</v-icon>
                  </v-btn>
                </v-layout>
              </v-flex>

              <!-- Rehber -->
              <v-flex pl-1 xs11 sm11 md11>
                <genelarama
                  apiname="SaticiAra"
                  :tip="6"
                  :label="$t('Guide')"
                  v-model="val.kalem.kalemAcente.Rehber"
                ></genelarama>
              </v-flex>
              <v-flex xs1 sm1 md1>
                <v-layout row wrap fill-height align-end justify-center>
                  <v-btn icon small @click="miniEkle('rehber')">
                    <v-icon small>add</v-icon>
                  </v-btn>
                </v-layout>
              </v-flex>

              <!-- Transfer -->
              <v-flex pl-1 xs11 sm11 md11>
                <genelarama
                  apiname="SaticiAra"
                  :tip="2"
                  :label="$t('Transfer-v4')"
                  v-model="val.kalem.kalemAcente.Arac"
                >
                </genelarama>
              </v-flex>
              <v-flex xs1 sm1 md1>
                <v-layout row wrap fill-height align-end justify-center>
                  <v-btn icon small @click="miniEkle('transfer')">
                    <v-icon small>add</v-icon>
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex pl-1 xs4 sm4 md4>
            <v-layout row wrap>
              <!-- Otel -->
              <v-flex pl-1 xs11 sm11 md11>
                <genelarama
                  apiname="SaticiAra"
                  :tip="1"
                  :label="$t('Hotel')"
                  v-model="val.kalem.kalemAcente.OtelKodu"
                >
                </genelarama>
              </v-flex>
              <v-flex xs1 sm1 md1>
                <v-layout row wrap fill-height align-end justify-center>
                  <v-btn icon small @click="miniEkle('otel')">
                    <v-icon small>add</v-icon>
                  </v-btn>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-select
                  hide-details
                  :items="ogleyemegiitems"
                  item-text="text"
                  item-value="value"
                  :label="$t('Lunch')"
                  v-model="val.kalem.kalemAcente.OgleYemegi"
                >
                </v-select>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-select
                  hide-details
                  :items="girisitems"
                  item-text="text"
                  item-value="value"
                  :label="$t('Entries')"
                  v-model="val.kalem.kalemAcente.Girisler"
                >
                </v-select>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</v-tab-item>

                <v-tab-item :id="`tab-maliyet`">
                  <v-layout row wrap>
                    <v-card flat color="grey lighten-5">
                      <v-flex xs12 sm12 pa-1 md11>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md11>
                            <cariaracomp
                              v-bind:etiket="$t('Cost-Current')"
                              v-bind:value="val.kalem.maliyetCariKod.kod"
                              v-model="val.kalem.maliyetCariKod.kod"
                              :Coper="true"
                            ></cariaracomp>
                          </v-flex>
                               <v-flex xs12 sm12 md1 pt-2>
                            <v-tooltip bottom>
                               <v-btn @click="getMaliyetCari()"  slot="activator" flat icon color="primary">
                              <v-icon>swipe_left_alt</v-icon>
                            </v-btn>
                            <span> {{$t('Bring-Seller-Client')}} </span>
                            </v-tooltip>
                           </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-text-field
                              hide-details
                              :label="$t('Profit-VAT')"
                              mask="#####"
                              v-model="val.kalem.karKDV"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <kur
                              v-model="val.kalem.alisPara"
                              :kurtarihi="val.Rez.kayitTarihi"
                            >
                            </kur>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-combobox
                              hide-details
                              :label="$t('Rom-Pax-Total')"
                              v-model="val.kalem.kalemAcente.RP"
                              :items="['R', 'P', 'T']"
                            >
                            </v-combobox>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <kredikartodemetipi
                              v-model="val.kalem.KKartOdemeTipi"
                              @input="kKartKontrol()"
                            ></kredikartodemetipi>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <kredikartnoara
                              v-bind:value="val.kalem.KKartNo"
                              v-model="val.kalem.KKartNo"
                              v-bind:kartTipi="val.kalem.KKartOdemeTipi"
                            ></kredikartnoara>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <parainput
                            :isPositive="true"
                             simge=""
                              :etiket="$t('YetBuying')"
                              v-model="val.kalem.yet_Alis"
                              :autocomplete="'autocomplete'"
                            ></parainput>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <parainput
                            :isPositive="true"
                             simge=""
                              :etiket="$t('co1buying')"
                              v-model="val.kalem.co1_Alis"
                              :autocomplete="'autocomplete'"
                            ></parainput>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-card>
                  </v-layout>
                </v-tab-item>

                <v-tab-item :id="`tab-komisyon`">
                  <v-layout row wrap>
                    <v-card flat color="grey lighten-5">
                      <v-flex xs12 sm12 pa-1 md12>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-autocomplete
                              hide-details
                              :label="$t('Calculate-Commission-Percentage')"
                              v-model="val.kalem.komisyonYuzdeTip"
                              item-text="t"
                              item-value="v"
                              :items="[
                                { t: $t('Calculate-From-Sales-Price'), v: 0 },
                                { t: $t('Calculate-From-Purchasing-Price'), v: 1 },
                              ]"
                            >
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <yuzdeinput
                            :isPositive="true"
                              :etiket="$t('Commission-Percentage')"
                              v-model="val.kalem.komisyonYuzde"
                              :autocomplete="'autocomplete'"
                            ></yuzdeinput>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <parainput
                            :isPositive="true"
                             simge=""
                              :etiket="$t('Commission-Amount-v2')"
                              v-model="val.kalem.komisyonTutar"
                              :autocomplete="'autocomplete'"
                            ></parainput>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <kur
                              v-model="val.kalem.komisyonPara"
                              :kurtarihi="val.Rez.kayitTarihi"
                            >
                            </kur>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-text-field
                              :label="$t('Commission-VAT')"
                              v-model="val.kalem.komisyon.KDVOran"
                              
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-card>
                  </v-layout>
                </v-tab-item>

                <v-tab-item :id="`tab-aciklama`">
                  <v-card flat color="grey lighten-5">
                    <v-flex xs12 sm12 pa-1 md12>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                          <v-textarea
                            hide-details
                            :label="$t('Descriptions')"
                            v-model="val.kalem.aciklama"
                          >
                          </v-textarea>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-textarea
                            hide-details
                            :label="$t('Supplier-Explanations')"
                            v-model="val.kalem.tedarikciAciklama"
                          ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card>
                </v-tab-item>

                <v-tab-item :id="`tab-diger`">
                  <v-card flat color="grey lighten-5">
                    <v-flex xs12 sm12 pa-1 md12>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                          <v-text-field
                            hide-details
                            :label="$t('Integration-Code')"
                            v-model="val.kalem.entegrasyonKodu"
                          >
                          </v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <geneltipara
                            tip="CariKdvKod"
                            hide-details
                            :label="$t('VAT-Code')"
                            v-model="val.kalem.kdvID"
                          >
                          </geneltipara>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <geneltipara
                            tip="CariKdvIstisnaKod"
                            hide-details
                            :label="$t('VAT-Exception-Code')"
                            v-model="val.kalem.kdvMuafiyetID"
                          >
                          </geneltipara>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 md3 sm3>
          <v-flex xs12 sm12 md12>
            <v-card color="grey lighten-5" flat>
              <v-layout row wrap>
                <v-flex xs12 pa-2 sm12 md12>
                  <v-layout row wrap>
                    <v-flex pl-1 xs12 sm12 md12>
                      <v-layout justify-center>
                        <v-checkbox
                          v-model="tumunusec"
                          :label="$t('Person-List')"
                          color="info"
                          hide-details
                        >
                        </v-checkbox>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                </v-flex>

                <v-flex
                  pa-2
                  v-for="item in val.Kisiler"
                  v-bind:key="item.id"
                  xs12
                  sm12
                  md12
                >
                  <v-card flat="">
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex xs2 sm2 md2>
                              <v-layout
                                align-start=""
                                justify-start
                                fill-height
                              >
                                <v-card flat="">
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>
                                      <div
                                        class="font-weight grey--text caption"
                                      >
                                        <v-checkbox
                                          v-model="secilenkayitlar"
                                          :value="item"
                                          hide-details
                                        >
                                        </v-checkbox>
                                      </div>
                                    </v-list-tile-sub-title>
                                    <v-list-tile-sub-title>
                                      <div
                                        class="font-weight green--text body-2"
                                      >
                                        &nbsp;
                                      </div>
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                </v-card>
                              </v-layout>
                            </v-flex>
                            <v-flex xs5 sm5 md5>
                              <v-layout
                                align-center=""
                                justify-start=""
                                fill-height=""
                              >
                                <v-icon color="red">person</v-icon>
                                <span
                                  class="caption black--text font-weight-regular"
                                >
                                  {{ KisiTipToStr(item.kisiTip) }}
                                </span>
                              </v-layout>
                            </v-flex>

                            <v-flex xs5 sm5 md5>
                              <v-layout
                                align-center=""
                                justify-start=""
                                fill-height=""
                              >
                                <span
                                  class="caption black--text font-weight-regular"
                                >
                                  {{ item.adSoyad }}
                                </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 pa-2 sm12 md12>
                  <v-layout row wrap>
                    <v-flex v-if="val.islem == 'new'" pb-1 xs12 sm12 md12>
                      <v-btn outline @click="kalemekle()" block color="info">
                        {{$t('Add-Reservation-List')}}</v-btn
                      >
                    </v-flex>
                    <v-flex
                      @click="kalemguncelle()"
                      v-if="val.islem == 'edit'"
                      pb-1
                      xs12
                      sm12
                      md12
                    >
                      <v-btn outline block color="info"> {{ $t('Update') }}</v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 md12>
                      <v-btn
                        outline
                        @click.native="val.aktif = false"
                        block
                        color="info"
                        >{{ $t("cancel_button") }}
                      </v-btn>
                    </v-flex> -->
                  </v-layout>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import rez from "../rezervasyon";
import kur from "@/components/app/coper/comp/kur.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import genelaramakod from "@/components/app/coper/comp/genelaramakod.vue";
import tarihcomp from "../../customcomp/tarihim";
import parainput from "../../customcomp/parainput";
import yuzdeinput from "../../customcomp/yuzdeinput";
import tasimatipi from "@/components/app/coper/component/tasimatipi.vue";
import aracalanara from "@/components/app/coper/component/aracalanara.vue";
import rehbersoforara from "@/components/app/coper/component/rehbersoforara.vue";
import digeriskodu from "@/components/app/coper/component/digeriskodu.vue";
import minisaticieklecomp from "@/components/app/coper/component/minisaticieklecomp.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import cariaracomp from "@/components/app/customcomp/cariaracomp.vue";
import tool from "../tools";
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
import kredikartodemetipi from "@/components/app/coper/comp/kredikartodemetipi.vue";
import kredikartnoara from "@/components/app/coper/comp/kredikartnoara.vue";
import resultDialog from "@/components/app/customcomp/resultDialog.vue"
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import auth from "../../../../api/auth";

export default {
  components: {
    snackbarcomp,
    resultDialog,
    kur,
    genelarama,
    genelaramakod,
    tarihcomp,
    geneltipara,
    parainput,
    yuzdeinput,
    tasimatipi,
    aracalanara,
    rehbersoforara,
    digeriskodu,
    minisaticieklecomp,
    cariaracomp,
    kredikartodemetipi,
    kredikartnoara,
  },
  watch: {
    "val.kalem.satici.kod": function (val1) {
      this.val.kalem.satis.KDVOran = parseFloat(this.val.kalem.satici.KDV);

      //      if (this.val.kalem.satici.YurtIci_YurtDisi == 0) {
      //    this.val.kalem.satis.KDVOran = 18
      //      } else {
      //          this.val.kalem.satis.KDVOran = 8
      //      }
      this.turkodugetir();
    },
    secilenkayitlar: function (val) {
      if (this.counter == 0 && this.val.islem != "new") {
        this.counter = this.counter + 1;
      } else {
        if (this.val.kalem.P_RP == "R") {
          if (this.val.islem == "new"){
            this.val.kalem.yet_KisiSayisi = this.secilenkayitlar.length;
          }
         
        } else {
          if (this.val.islem == "new"){
  this.val.kalem.yet_KisiSayisi = 0;
          this.val.kalem.co1_KisiSayisi = 0;
          this.val.kalem.co2_KisiSayisi = 0;
          this.val.kalem.co3_KisiSayisi = 0;
          this.val.kalem.co4_KisiSayisi = 0;
          this.val.kalem.ekY_KisiSayisi = 0;
          
        

          val.forEach((element) => {
            if (element.kisiTip == 0) {
              this.val.kalem.yet_KisiSayisi = this.val.kalem.yet_KisiSayisi + 1;
            } else if (element.kisiTip == 1) {
              this.val.kalem.co1_KisiSayisi = this.val.kalem.co1_KisiSayisi + 1;
            } else if (element.kisiTip == 2) {
              this.val.kalem.co2_KisiSayisi = this.val.kalem.co2_KisiSayisi + 1;
            } else if (element.kisiTip == 3) {
              this.val.kalem.co3_KisiSayisi = this.val.kalem.co3_KisiSayisi + 1;
            } else if (element.kisiTip == 4) {
              this.val.kalem.co4_KisiSayisi = this.val.kalem.co4_KisiSayisi + 1;
            } else if (element.kisiTip == 5) {
              this.val.kalem.ekY_KisiSayisi = this.val.kalem.ekY_KisiSayisi + 1;
            }
          });
          }
        }
      }
    },
    "val.kalem.P_RP": function (val) {
      if (val == "R") {
         if (this.val.islem == "new"){
this.val.kalem.yet_KisiSayisi = this.secilenkayitlar.length;
         }
        
      } else {
        if (this.val.islem == "new"){
 this.val.kalem.yet_KisiSayisi = 0;
        this.val.kalem.co1_KisiSayisi = 0;
        this.val.kalem.co2_KisiSayisi = 0;
        this.val.kalem.co3_KisiSayisi = 0;
        this.val.kalem.co4_KisiSayisi = 0;
        this.val.kalem.ekY_KisiSayisi = 0;

        this.secilenkayitlar.forEach((element) => {
          if (element.kisiTip == 0) {
            this.val.kalem.yet_KisiSayisi = this.val.kalem.yet_KisiSayisi + 1;
          } else if (element.kisiTip == 1) {
            this.val.kalem.co1_KisiSayisi = this.val.kalem.co1_KisiSayisi + 1;
          } else if (element.kisiTip == 2) {
            this.val.kalem.co2_KisiSayisi = this.val.kalem.co2_KisiSayisi + 1;
          } else if (element.kisiTip == 3) {
            this.val.kalem.co3_KisiSayisi = this.val.kalem.co3_KisiSayisi + 1;
          } else if (element.kisiTip == 4) {
            this.val.kalem.co4_KisiSayisi = this.val.kalem.co4_KisiSayisi + 1;
          } else if (element.kisiTip == 5) {
            this.val.kalem.ekY_KisiSayisi = this.val.kalem.ekY_KisiSayisi + 1;
          }
        });
        }
       
      }
    },
    tumunusec(valsec) {
       if (this.val.islem == "new"){
 this.val.kalem.yet_KisiSayisi = 0;
      this.val.kalem.co1_KisiSayisi = 0;
      this.val.kalem.co2_KisiSayisi = 0;
      this.val.kalem.co3_KisiSayisi = 0;
      this.val.kalem.co4_KisiSayisi = 0;
      this.val.kalem.ekY_KisiSayisi = 0;
       }
     
      if (valsec == true) {
        for (var i = 0; i < this.val.Kisiler.length; i++) {
          this.secilenkayitlar.push(this.val.Kisiler[i]);
        }
        if (this.val.kalem.P_RP == "R") {
          //this.val.kalem.yet_KisiSayisi = this.val.Kisiler.length;
        } else {
           if (this.val.islem == "new"){
 this.secilenkayitlar.forEach((element) => {
            if (element.kisiTip == 0) {
              this.val.kalem.yet_KisiSayisi = this.val.kalem.yet_KisiSayisi + 1;
            } else if (element.kisiTip == 1) {
              this.val.kalem.co1_KisiSayisi = this.val.kalem.co1_KisiSayisi + 1;
            } else if (element.kisiTip == 2) {
              this.val.kalem.co2_KisiSayisi = this.val.kalem.co2_KisiSayisi + 1;
            } else if (element.kisiTip == 3) {
              this.val.kalem.co3_KisiSayisi = this.val.kalem.co3_KisiSayisi + 1;
            } else if (element.kisiTip == 4) {
              this.val.kalem.co4_KisiSayisi = this.val.kalem.co4_KisiSayisi + 1;
            } else if (element.kisiTip == 5) {
              this.val.kalem.ekY_KisiSayisi = this.val.kalem.ekY_KisiSayisi + 1;
            }
          });
           }
         
        }
      } else {
        this.secilenkayitlar = [];
        if (this.val.islem == "new"){
 this.val.kalem.yet_KisiSayisi = 0;
        this.val.kalem.co1_KisiSayisi = 0;
        this.val.kalem.co2_KisiSayisi = 0;
        this.val.kalem.co3_KisiSayisi = 0;
        this.val.kalem.co4_KisiSayisi = 0;
        this.val.kalem.ekY_KisiSayisi = 0;
        }
       
      }

      // if (valsec == true) {
      //   this.secilenkayitlar = this.val.Kisiler;
      // } else {
      //   this.secilenkayitlar = [];
      // }
    },
  },

  props: ["value"],
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },

  data() {
    return {
      acentedepartmandialog:false,
       loadData: {
        Id: null,
        Ad: null,
        Aciklama: null,
        AcenteDepartman: {
          MasrafMerkezi: null,
          EFaturaSeri: null,
        },
        Tevkifat: null,
      },
      dialogMasrafMerkezi:false,
      Masrafmerkezi:{
Code:"",
CodeName:""
      },
      PB:'TRY',
      text1: "",
      snackbar: false,
      turkoduitems: [],
      turturuitems: rez.TurTuru(),
      ogleyemegiitems: [
        {
          text: "",
          value: 0,
        },
        {
          text: "Dahil",
          value: 1,
        },
        {
          text: this.$t('Excluding'),
          value: 2,
        },
      ],

      girisitems: [
        {
          text: "",
          value: 0,
        },
        {
          text: "Dahil",
          value: 1,
        },
        {
          text: this.$t('Excluding'),
          value: 2,
        },
      ],

      pantipitems: [
        {
          text: "",
          value: 0,
        },
        {
          text: this.$t('Full'),
          value: 1,
        },
        {
          text: this.$t('Half'),
          value: 2,
        },
        {
          text: this.$t('night'),
          value: 3,
        },
      ],
      aractipitems: [],
      menu2: false,
      menu1: false,
      ucusnoitems: [],
      rehberdilitems: [],
      transfertipitems: [
        {
          text: this.$t('None'),
          value: "Yok",
        },
        {
          text: this.$t('Golf-course-tasks'),
          value: "Golf Sahası Yapacak",
        },
        {
          text: this.$t('Agency-tasks'),
          value: "Acenta Yapacak",
        },
      ],
      tumunusec: false,
      secilenkayitlar: [],
      dialogShow: false,
      error: "",
      adresler: [],
      search: "",
      selected: [],
      odemeTipi: rez.OdemeTipi,

      tabmodel: "tab-genel",

      kisiSira: [],
      headers: [
        {
          text: "Isim",
          align: "left",
          value: "adSoyad",
          sortable: false,
        },
      ],
      menuItems: [
        {
          title: this.$t('Find-Price')
        },
        {
          title: this.$t('Calculate-Price')
        },
      ],
    };
  },

  created() {},
  methods: {
    KaydetAcenteDepartman() {
      let params = {
        TanitimTip: 6,
      };
      params = Object.assign(params, this.loadData);

      tool.http_post(this, "GenelTipTanitimInsert", params).then(
        (response) => {
          if (response.body.Status == true) {
           
            this.acentedepartmandialog = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
   
    KaydetMasrafMerkezi(){
var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params1 = {
          CompanyCode: credentials.SirketKodu,
        }

        this.Masrafmerkezi.CompanyCode = credentials.SirketKodu

        var params = this.Masrafmerkezi

        this.$http.post(auth.API_URL + 'api/ExpenseCenter/New', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status==false) {
             
               this.text1 = this.$t(response.body.ResponseMessage)
              this.snackbar = true
              this.dialogMasrafMerkezi=false;
              return;
          }
         this.dialogMasrafMerkezi=false;
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            his.dialogMasrafMerkezi=false;
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            his.dialogMasrafMerkezi=false;
          }
        })
    },
  miniEkle(type) {
    if (type=="otel"){
       let url = "#/coper/saticilar/islem/id?isl=yeni&tip=1&kapat=1";
        window.open(url, "_blank");
    }
     if (type=="transfer"){
       let url = "#/coper/saticilar/islem/id?isl=yeni&tip=2&kapat=1";
        window.open(url, "_blank");
    }
     if (type=="rehber"){
       let url = "#/coper/saticilar/islem/id?isl=yeni&tip=6&kapat=1";
        window.open(url, "_blank");
    }
      if (type=="gemi"){
       let url = "#/coper/saticilar/islem/id?isl=yeni&tip=9&kapat=1";
        window.open(url, "_blank");
    }
     if (type=="departman"){
      this.acentedepartmandialog=true;
    }
      if (type=="masrafMerkezi"){
       this.dialogMasrafMerkezi=true;
    }
    
  },
      getMaliyetCari(){
      this.val.kalem.maliyetCariKod.kod = this.val.kalem.satici.CariKod;
    },
    kKartKontrol() {
      this.val.kalem.KKartNo = "";
    },
    getparabirimi() {
      return helpers.getparabirimiDefault();
    },
    turkodugetir() {
      var params = {
        SaticiKodu: this.val.kalem.satici.kod,
      };

      tool.http_post(this, "AcenteTurlar", params).then(
        (response) => {
        for (const element of response.body.data) {
    this.turkoduitems.push(element.Kod);
}
         
        },
        (response) => {
          this.text1 = this.$t('Location-could-not-found-error-occured');
          this.snackbar = true;
        }
      );
    },
    kalemekle() {
    if(this.val.kalem.yet_KisiSayisi == ''){
        this.snackbar = true;
        this.text1 = this.$t('Number-of-Adults-cannot-be-empty');
        return false;
    }

    if(this.val.kalem.satici.kod == null || this.val.kalem.satici.kod == ""){
        let data ={
        response: {},
        request:{},
        api:'kalemSaticiKontrol',
        type:2,
         message: this.$t('Vendor-cannot-be-empty-Please-add-Seller')
        };
        this.$refs.showMessage.open(data);
        return false;
    }

      if(this.secilenkayitlar.length == 0 ){
              this.text1 = this.$t('Contact-List-cannot-be-empty-Please-add-person');
              this.snackbar = true;
              return false;
      }
      if (this.val.kalem.P_RP == "P") {
      } else {
        // this.val.kalem.yet_Satis = 0;
        this.val.kalem.co1_Satis = 0;
        this.val.kalem.co2_Satis = 0;
        this.val.kalem.co3_Satis = 0;
        this.val.kalem.co4_Satis = 0;
        this.val.kalem.ekY_Satis = 0;

        //this.val.kalem.yet_KisiSayisi = this.secilenkayitlar.length;
        this.val.kalem.co1_KisiSayisi = 0;
        this.val.kalem.co2_KisiSayisi = 0;
        this.val.kalem.co3_KisiSayisi = 0;
        this.val.kalem.co4_KisiSayisi = 0;
        this.val.kalem.ekY_KisiSayisi = 0;
      }

      this.val.kalem.kalemDiger = null;
      this.val.kalem.kalemArac = null;
      this.val.kalem.kalemRentACar = null;
      this.val.kalem.kalemVize = null;
      //this.val.kalem.kalemAcente = null
      this.val.kalem.kalemCharter = null;
      this.val.kalem.kalemFeribot = null;
      this.val.kalem.kalemGemi = null;
      this.val.kalem.kalemGolf = null;
      this.val.kalem.kalemMuze = null;
      this.val.kalem.kalemOtel = null;
      this.val.kalem.kalemRehber = null;
      this.val.kalem.kalemRestaurant = null;
      this.val.kalem.kalemSigorta = null;
      this.val.kalem.kisiSira = [];

      this.secilenkayitlar.forEach((element) => {
        var a = this.val.Kisiler.indexOf(element);

        if (a != -1) {
          this.val.kalem.kisiSira.push(a);
        }
      });

      this.val.Rez.kalemler.push(this.val.kalem);
      this.val.islem = "new";
      this.val.aktif = false;
    },
    kalemguncelle() {
    if(this.val.kalem.yet_KisiSayisi == ''){
        this.snackbar = true;
        this.text1 = this.$t('Number-of-Adults-cannot-be-empty');
        return false;
    }

    if(this.val.kalem.satici.kod == null || this.val.kalem.satici.kod == ""){
        let data ={
        response: {},
        request:{},
        api:'kalemSaticiKontrol',
        type:2,
         message: this.$t('Vendor-cannot-be-empty-Please-add-Seller')
        };
        this.$refs.showMessage.open(data);
        return false;
    }

      if(this.secilenkayitlar.length == 0 ){
          this.text1 = this.$t('Contact-List-cannot-be-empty-Please-add-person');
         this.snackbar = true; 
       return false;
      }

      if (this.val.kalem.P_RP == "P") {
      } else {
        this.val.kalem.co1_Satis = 0;
        this.val.kalem.co2_Satis = 0;
        this.val.kalem.co3_Satis = 0;
        this.val.kalem.co4_Satis = 0;
        this.val.kalem.ekY_Satis = 0;

        //this.val.kalem.yet_KisiSayisi = this.secilenkayitlar.length;
        this.val.kalem.co1_KisiSayisi = 0;
        this.val.kalem.co2_KisiSayisi = 0;
        this.val.kalem.co3_KisiSayisi = 0;
        this.val.kalem.co4_KisiSayisi = 0;
        this.val.kalem.ekY_KisiSayisi = 0;
      }

      this.val.kalem.kalemDiger = null;
      this.val.kalem.kalemArac = null;
      this.val.kalem.kalemRentACar = null;
      this.val.kalem.kalemVize = null;
      //this.val.kalem.kalemAcente = null
      this.val.kalem.kalemCharter = null;
      this.val.kalem.kalemFeribot = null;
      this.val.kalem.kalemGemi = null;
      this.val.kalem.kalemGolf = null;
      this.val.kalem.kalemMuze = null;
      this.val.kalem.kalemOtel = null;
      this.val.kalem.kalemRehber = null;
      this.val.kalem.kalemRestaurant = null;
      this.val.kalem.kalemSigorta = null;

      this.val.kalem.kisiSira = [];

      this.secilenkayitlar.forEach((element) => {
        var a = this.val.Kisiler.indexOf(element);

        if (a != -1) {
          this.val.kalem.kisiSira.push(a);
        }
      });

      this.val.Rez.kalemler.splice(this.val.recordno, 1, this.val.kalem);
      this.val.aktif = false;
      this.val.islem = "new";
    },

    KisiTipToStr(tip) {
      return rez.KisiTipToStr(tip);
    },
    menuClick: menuClick,
    SaticiTipToStr(tip) {
      return rez.SaticiTipToStr(tip);
    },
    setSelected(v) {
      this.selected = v;
    },
    setDialogShow(v) {
      this.dialogShow = v;
    },

    close() {
      this.value.dialogShow = false;
      setTimeout(() => {
        this.value.kalem = Object.assign({}, rez.Kalem());

        this.value.editedIndex = -1;
      }, 300);
    },

    modalOk() {
      this.value.kalem.kisiSira = [];
      for (var i = 0; i < this.selected.length; i++) {
        this.value.kalem.kisiSira.push(this.selected[i].kisiSira);
      }

      if (this.value.editedIndex > -1) {
        Object.assign(
          this.value.Rez.kalemler[this.value.editedIndex],
          this.value.kalem
        );
      } else {
        this.value.Rez.kalemler.push(this.value.kalem);
      }
      this.close();
    },
  },
  mounted() {
    if (this.val.islem == "new") {
       var credentials = JSON.parse(window.localStorage.getItem("credentials"));
    this.PB=credentials.ParaBirimi;
    var yazpb=this.PB;
    if (yazpb=="TRY"){
      yazpb="TL";
    }
        this.val.kalem.satisPara.paraBirimi=yazpb;
      this.val.kalem.komisyonPara.paraBirimi=yazpb;
      this.val.kalem.alisPara.paraBirimi=yazpb;
      
      this.val.kalem.masrafMerkezi = this.value.Rez.masrafMerkezi;
      this.secilenkayitlar = [];

      for (var i = 0; i < this.value.Kisiler.length; i++) {
        this.secilenkayitlar.push(this.value.Kisiler[i]);
      }
    } else {
      this.val.kalem.masrafMerkezi = this.value.Rez.masrafMerkezi;
      this.secilenkayitlar = [];
      for (var i = 0; i < this.value.kalem.kisiSira.length; i++) {
        this.secilenkayitlar.push(
          this.value.Rez.adresler[this.value.kalem.kisiSira[i]]
        );
      }
    }

    this.turkodugetir();

    var params = {};
    tool.http_post(this, "DillerList", params).then(
      (response) => {
        if (response.body.Status == true) {
          this.rehberdilitems = response.body.data;
        } else {
          this.text1 = response.body.ErrorList[0];
          this.snackbar = true;
        }
      },
      (response) => {
        this.text1 = this.$t('An-error-has-occurred-Please-try-again');
        this.snackbar = true;
      }
    );
  },
};

function menuClick(v) {}
</script>